import { useContext } from "react";
import { SettingsContext, ShopContext, TableContext } from "../App";
import LockIcon from "../icons/LockIcon";
import "../css/Pin.css";

// Benvenuto al cliente dopo che l'operatore ha consegnato il tablet (modalità tablet, YELLGO-6125).
// Il lucchetto in basso a destra riapre il PIN operatore (StaffPin in overlay).
function TabletWelcome() {
  const { settings, setTabletWelcome, setStaffGateVisible } = useContext(SettingsContext);
  const { shop } = useContext(ShopContext);
  const { table } = useContext(TableContext);

  const covers = parseInt(table?.covers) || 0;
  const tableInfo = [[table?.name, shop?.name].filter(Boolean).join(" · "), table?.room?.name]
    .filter(Boolean)
    .join(" - ");
  const pill = [tableInfo, covers > 0 ? covers + (covers === 1 ? " coperto" : " coperti") : null]
    .filter(Boolean)
    .join(" · ");

  return (
    <div id="pin" className="tablet-welcome">
      <div className="staff-pin-logo">
        <img src={settings.selfordering.logo_home} alt="Logo" />
      </div>
      <div className="tablet-welcome-body">
        {pill && <div className="tablet-welcome-pill">{pill}</div>}
        <h1>Benvenuti!</h1>
        <p>Sfogliate il menu e inviate i vostri ordini direttamente da questo tablet.</p>
        <button type="button" className="tablet-welcome-start" onClick={() => setTabletWelcome(false)}>
          Inizia a ordinare
        </button>
      </div>
      <div className="tablet-welcome-footer">
        <span>{table?.list?.name ? "Listino: " + table.list.name : ""}</span>
        <button
          type="button"
          className="tablet-welcome-lock"
          aria-label="Accesso operatore"
          onClick={() => setStaffGateVisible(true)}
        >
          <LockIcon size={18} />
        </button>
      </div>
    </div>
  );
}

export default TabletWelcome;
